export const CLIENT_LIB_VERSION = '1.35.0'
